export function removeTags(str: string): string {
  if (str === null || str === '') return null
  else str = str.toString()
  return str.replace(/(<([^>]+)>)/gi, '').replace(/&nbsp;/g, '')
}
